import {
	CHECKLIST_ACTION_TYPES,
	ChecklistActionTypes,
	ChecklistState,
} from '../../../../types/checklist'

const initialState: ChecklistState = {
	checklistTimeline: [],
	count: 0,
}

export default (
	state = initialState,
	action: ChecklistActionTypes
): ChecklistState => {
	switch (action.type) {
		case CHECKLIST_ACTION_TYPES.CHECKLIST_TIMELINE_GET: {
			return {
				...state,
				checklistTimeline: action.payload?.paginatedResults || [],
				count: action.payload?.totalCount?.[0]?.count || 0,
			}
		}

		case CHECKLIST_ACTION_TYPES.CHECKLIST_TIMELINE_EDIT_ITEM: {
			const updateChecklistTimeline = [action.payload, ...state.checklistTimeline]

			return {
				...state,
				checklistTimeline: updateChecklistTimeline,
				count: state.count + 1,
			}
		}

		case CHECKLIST_ACTION_TYPES.CHECKLIST_TIMELINE_GET_MORE: {
			const newChecklists = action.payload?.paginatedResults || []

			const updatedChecklistTimeline = [
				...new Map(
					[...state.checklistTimeline, ...newChecklists].map(el => [el._id, el])
				).values(),
			]

			return {
				...state,
				checklistTimeline: updatedChecklistTimeline,
			}
		}
		default: {
			return state
		}
	}
}
